<div *ngIf="isLoading" class="overlay"></div>
<div *ngIf="isLoading" class="loader"></div>
<div *ngIf="!isLoading" class="example-inner">
  <div class="container">
    <div class="header">
        <button mat-raised-button 
              color="primary" 
              class="dashboard-button" 
              routerLink="/sales/generaldash">
        <mat-icon>dashboard</mat-icon>
        <span>Sales Dashboard</span>
        </button>
        <h1 class="page-title" >Date Range Search</h1>
    </div>
        <div class="button-groups">
          <form [formGroup]="dateForm">
            From: <input  name="getDate" matInput formControlName="getDate" /> <span><strong>&nbsp; (DD/MM/YYYY) &nbsp;</strong></span>
            To: <input  name="getDateTo" matInput formControlName="getDateTo" /> <span><strong>&nbsp; (DD/MM/YYYY) &nbsp;</strong></span>
            <button style="float: none;" type="button" mat-raised-button (click)="getDay()" color="warn">Get Sales</button>
          </form>
          <!--<button (click)="RandomDataset()" nz-button nzType="default">Refresh Charts</button> -->
        </div>
        <!--<div *ngIf="!isLoading" echarts [options]="options" [merge]="mergeOptions" class="demo-chart"></div>-->
        <div class="demo-container">
          <div style="background-color: lightcyan;">
            <span><strong>Creams</strong></span>
            <kendo-grid
              [data]="gridDataTab1"
              [height]="400"
              [pageSize]="gridStateTab1.take"
              [skip]="gridStateTab1.skip"
              [pageable]="false"
              [sortable]="false"
              [size]="smallSize"
              (dataStateChange)="dataStateChangeTab1($event)"
            >
            <kendo-grid-column field="dated" title="Date">
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.dated | date: 'dd/MM/yy'}}
            </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="weekDay" title="Day"></kendo-grid-column>
            <kendo-grid-column field="eleven" title="11" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab1Now["eleven"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="twelve" title="12" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab1Now["twelve"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="thirteen" title="13" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab1Now["thirteen"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="fourteen" title="14" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab1Now["fourteen"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="fifteen" title="15" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab1Now["fifteen"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="sixteen" title="16" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab1Now["sixteen"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="seventeen" title="17" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab1Now["seventeen"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="eighteen" title="18" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab1Now["eighteen"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="nineTeen" title="19" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab1Now["nineTeen"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="twenty" title="20" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab1Now["twenty"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="twentyOne" title="21" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab1Now["twentyOne"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="twentyTwo" title="22" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab1Now["twentyTwo"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="totalSales" title="Total" format="£ ##,###.##">
              <ng-template kendoGridFooterTemplate> 
                <span style='float: right'>
                  {{ totalTab1Now["totalSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            </kendo-grid>
          </div>
        </div>
        <br/><br/>
        <div class="demo-container">
          <div style="background-color: lightcyan;">
            <span><strong>MH</strong></span>
            <kendo-grid
              [data]="gridDataTab2"
              [height]="400"
              [pageSize]="gridStateTab2.take"
              [skip]="gridStateTab2.skip"
              [pageable]="false"
              [sortable]="false"
              [size]="smallSize"
            >
            <kendo-grid-column field="dated" title="Date">
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.dated | date: 'dd/MM/yy'}}
            </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="weekDay" title="Day"></kendo-grid-column>
            <kendo-grid-column field="eleven" title="11" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab2["eleven"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="twelve" title="12" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab2["twelve"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="thirteen" title="13" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab2["thirteen"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="fourteen" title="14" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab2["fourteen"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="fifteen" title="15" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab2["fifteen"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="sixteen" title="16" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab2["sixteen"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="seventeen" title="17" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab2["seventeen"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="eighteen" title="18" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab2["eighteen"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="nineTeen" title="19" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab2["nineTeen"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="twenty" title="20" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab2["twenty"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="twentyOne" title="21" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab2["twentyOne"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="twentyTwo" title="22" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab2["twentyTwo"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="totalSales" title="Total" format="£ ##,###.##">
              <ng-template kendoGridFooterTemplate> 
                <span style='float: right'>
                  {{ totalTab2["totalSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            </kendo-grid>
          </div>
        </div>
        <br/><br/>
        <div class="demo-container">
          <div style="background-color: lightcyan;">
            <span><strong>DISHD</strong></span>
            <kendo-grid
              [data]="gridDataTab3"
              [height]="400"
              [pageSize]="gridStateTab3.take"
              [skip]="gridStateTab3.skip"
              [pageable]="false"
              [sortable]="false"
              [size]="smallSize"
            >
            <kendo-grid-column field="dated" title="Date">
              <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.dated | date: 'dd/MM/yy'}}
            </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="weekDay" title="Day"></kendo-grid-column>
            <kendo-grid-column field="eleven" title="11" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab3["eleven"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="twelve" title="12" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab3["twelve"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="thirteen" title="13" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab3["thirteen"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="fourteen" title="14" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab3["fourteen"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="fifteen" title="15" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab3["fifteen"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="sixteen" title="16" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab3["sixteen"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="seventeen" title="17" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab3["seventeen"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="eighteen" title="18" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab3["eighteen"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="nineTeen" title="19" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab3["nineTeen"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="twenty" title="20" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab3["twenty"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="twentyOne" title="21" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab3["twentyOne"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="twentyTwo" title="22" format="£ ##,###.#">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalTab3["twentyTwo"].sum.toFixed(1) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="totalSales" title="Total" format="£ ##,###.##">
              <ng-template kendoGridFooterTemplate> 
                <span style='float: right'>
                  {{ totalTab3["totalSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            </kendo-grid>
          </div>
        </div>
</div>
</div>
